/* eslint-disable enforce-catch-error-handled/require-catch-error-handling */
// TODO: Remove this eslint-disable comment in a separate PR (RCP-27576)
import {
  EventBridgeClient,
  PutEventsCommand,
} from '@aws-sdk/client-eventbridge';
import type { EmailTemplate } from '@issuemanager/features/notification/constants';
import pino from 'pino';

const eventBridgeClient = new EventBridgeClient({});

export type SendNotificationParams<T = any> = {
  type: EmailTemplate;
  payload: T;
  orgDetail?: { id: string; name?: string };
  userDetail?: { id: string };
  recipients: string[];
};
export async function sendNotification<T = any>(
  params: SendNotificationParams<T>,
): Promise<void> {
  const logger = pino();

  try {
    if (!params.recipients.length) {
      return;
    }

    logger.info({
      message: 'Sending email notification',
      data: {
        type: params.type,
        payload: params.payload,
        orgDetail: params.orgDetail,
        userDetail: params.userDetail,
      },
    });

    const response = await eventBridgeClient.send(
      new PutEventsCommand({
        Entries: [
          {
            Source: 'IssueManager',
            DetailType: 'EmailNotification',
            Detail: JSON.stringify(params),
            EventBusName:
              process.env['PLATFORM_NOTIFICATION_SERVICE_EVENTBUS_ARN'],
          },
        ],
      }),
    );

    logger.info({ message: 'Email notification sent', data: response });
  } catch (error) {
    logger.error(error);
  }
}
